import React, {Component} from "react";
import Head from "../../components/Head";
import Subscribe from "../../components/Subscribe";
import {withTranslate} from "react-redux-multilingual"
import BlogSidebar from "../../components/blog/BlogSidebar";
import {connect} from "react-redux";
import CommentWrapper from "../../components/blog/CommentWrapper";
import AddBlogComment from "../../components/blog/AddBlogComment"
import {getPostDetails, clearBlogData, sendBlogComment} from "../../store/actions/blogActions";
import {splitStr} from "../../helpers/magic";
import ProgressiveImage from "react-progressive-image-loading";
import {baseBlogImageUrl} from "../../config";
import {setSinglePostSkeleton} from "../../skeleton";
import globalMiddleware from "../../hocs/globalMiddleware";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions";

class SingleBlog extends Component {
    state = {
        fields: {},
        errors: {},
        host: "http://localhost:8080",
        showCommentForm: true,
    };

    componentDidMount() {
        this.props.clearError500();
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
        const {post_name} = this.props.match.params;
        this.props.clearBlogData();
        this.props.getPostDetails(post_name);
    }

    // update status on change
    handleInputChange = (e, field) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({fields});
    };

    onSubmission(e, parent = null) {

        e.preventDefault();
        let data = this.state.fields;
        data.post_id = this.props.currentPost.ID;
        //to know if comment has replies or it is the first comment with no replies, if parent == 0 (comment has no replies)
        if (parent) {
            data.comment_parent = parent;
        } else {
            data.comment_parent = 0;
        }
        this.props.sendBlogComment(this.state.fields);
        this.setState({
            fields: {},
            errors: {},
        });
        e.target.reset();
    }


    handleShowCommentFormInSinglePage(status) {
        this.setState({
            showCommentForm: status
        })
    }

    render() {
        const {
            currentPost, categories, tags, currentPostIsLoading, postDetailsNotFound, postTags, currentPostError500,
            postComments, postReplies,
        } = this.props;
        if (postDetailsNotFound) {
            this.props.history.push("/404")
        }
        if (currentPostError500) {
            this.props.history.push("/maintenance")
        }
        let post_tags_split;
        if (postTags && postTags !== null) {
            post_tags_split = splitStr(postTags, ",");
        }
        //post tags
        const post_tags = post_tags_split && post_tags_split.length ? post_tags_split.map((postTag, tagIndex) => {
            return (
                <a href={"/blog/tag/" + postTag} key={tagIndex} className="tag-cloud-link">
                    {postTag}{(post_tags_split.length - 1) === tagIndex ? "" : ","}
                </a>
            )
        }) : null;
        //post comments
        const comments = postComments && postComments.length ? postComments.map((comment, index) => {
            return (
                <div className="comment-classic-group" key={index}>
                    <CommentWrapper replies={postReplies} comment={comment}
                                    post_id={currentPost ? currentPost.ID : null}
                                    errors={this.state.errors} fields={this.state.fields}
                                    onSubmission={(e, parent) => this.onSubmission(e, parent)}
                                    addingComment={this.props.addingComment}
                                    handleInputChange={(e, author) => this.handleInputChange(e, author)}
                                    handleShowCommentFormInSinglePage={(status) => this.handleShowCommentFormInSinglePage(status)}/>
                </div>
            )
        }) : null;

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];

        return (
            <div className="About">
                <Head title="Blog post" history={history}/>

                <section className="ftco-section ftco-degree-bg">
                    <div className="container">
                        <div className="row">
                            {currentPost && currentPostIsLoading === false ?
                                <div className="col-md-8 ftco-animate">
                                    <h2 className="mb-3">{currentPost.post_title}</h2>
                                    <ProgressiveImage
                                        preview="/images/blog-details-placeholder.png"
                                        src={baseBlogImageUrl + currentPost.featured_image}
                                        render={(src, style) => <img className="img-fluid mb-15" alt="" src={src}
                                                                     style={style}/>}
                                    />

                                    <div className="text"
                                         dangerouslySetInnerHTML={{__html: currentPost.post_content}}/>

                                    <div className="tag-widget post-tag-container mb-5 mt-5">
                                        <div className="tagcloud">
                                            {post_tags}
                                        </div>
                                    </div>

                                    <div className="pt-5 mt-5">
                                        {comments !== null ?
                                            <div>
                                                <h3 className="mb-5">{this.props.translate("comments")}</h3>

                                                {comments}
                                            </div>
                                            : ""}
                                        <div className="comment-form-wrap pt-5"
                                             hidden={this.state.showCommentForm === false}>
                                            <h2>{this.props.translate("leave_comment")}</h2>
                                            <div>
                                                <AddBlogComment errors={this.state.errors}
                                                                fields={this.state.fields}
                                                                onSubmission={(e) => this.onSubmission(e)}
                                                                addingComment={this.props.addingComment}
                                                                handleInputChange={(e, field) => this.handleInputChange(e, field)}/>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                : setSinglePostSkeleton(1)}

                            {/* Sidebar */}
                            <BlogSidebar handleSearch={""} slug={""} categories={categories} tags={tags}
                                         loading={currentPostIsLoading}/>
                        </div>
                    </div>
                </section>

                <Subscribe/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentPost: state.blog.currentPost,
        categories: state.blog.categories,
        tags: state.blog.tags,
        postTags: state.blog.postTags,
        currentPostIsLoading: state.blog.currentPostIsLoading,
        postDetailsNotFound: state.blog.postDetailsNotFound,
        currentPostError500: state.global.error500,
        addingComment: state.blog.addingComment,
        postComments: state.blog.postComments,
        postReplies: state.blog.postReplies,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPostDetails: (post_name) => dispatch(getPostDetails(post_name)),
        clearBlogData: () => dispatch(clearBlogData()),
        sendBlogComment: (data) => dispatch(sendBlogComment(data)),
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearError500: () => dispatch(clearError500())
    }
};
export default globalMiddleware(connect(mapStateToProps, mapDispatchToProps)(withTranslate(SingleBlog)));